import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptop, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import './Card.css';

const getCardBackgroundStyle = (url) => {
  return {
    backgroundImage: `url(${url})`
  }
}

const getCardTitleIcon = (subheading) => {
  if (subheading === 'RealOffice360™') return faLaptop;
  if (subheading === 'DressFresh®') return faMobileAlt;
}

const Card = (props) => {

  if (props.loading) {
    return (<div>...loading...</div>)
  }
  else {
    return (
      <div className="Card">

        <div className="CardImage" style={getCardBackgroundStyle(props.project.featured.imageUrl)}></div>

        <div className="Card__Contents">

          <div className="Card__TitleCtn">

            <div className="Card__TitleIcon">
              <FontAwesomeIcon icon={getCardTitleIcon(props.project.featured.subheading)} />
            </div>

            <div className="Card__TitleText">
              <div className="Card__Heading">{props.project.featured.heading}</div>
              <div className="Card__Subheading">{props.project.featured.subheading}</div>
            </div>
          </div>

          <div className="Card__Text">{props.project.featured.text}</div>
        </div>


        <div className="CardBottom">
          <div className="CardButton CardButton--Primary">
            <Link to={`/${props.project.category}/${props.project.id}`}>
              view details
            </Link>
          </div>
        </div>

      </div>
    )
  }
}

export default Card;


// WEBPACK FOOTER //
// ./src/components/Card/Card.js